import { render, staticRenderFns } from "./Society.vue?vue&type=template&id=56fae666&scoped=true&"
import script from "./Society.vue?vue&type=script&lang=js&"
export * from "./Society.vue?vue&type=script&lang=js&"
import style0 from "./Society.vue?vue&type=style&index=0&id=56fae666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fae666",
  null
  
)

export default component.exports